function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// @ts-nocheck
import * as React from 'react';
import { filterDataProps } from '../../utils/FilterDataProps';
import { CoreDropdownContent } from '../CoreDropdownContent';
import { CorePopover } from '../CorePopover';
import { CLICK, HOVER } from './constants';
import { st, classes } from './CoreDropdown.st.css';
var _React_PureComponent;
/**
 * Dropdown
 */ export class CoreDropdownComponent extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.initializeSelectedOptions();
    }
    componentDidUpdate(prevProps) {
        if (!CoreDropdownComponent.areSelectedIdsEqual(this.props.initialSelectedIds, prevProps.initialSelectedIds)) {
            this.initializeSelectedOptions();
        }
    }
    initializeSelectedOptions() {
        const { initialSelectedIds, options, onInitialSelectedOptionsSet } = this.props;
        const selectedOptions = (initialSelectedIds || []).map((id)=>options.find((option)=>id === option.id)).filter((option)=>option && !option.isDisabled && option.isSelectable);
        const selectedIds = selectedOptions.map((x)=>x && x.id);
        this.setState({
            selectedIds: selectedIds
        });
        onInitialSelectedOptionsSet && onInitialSelectedOptionsSet(selectedOptions);
    }
    handleClickOutside() {
        this.close();
    }
    _onExpandedChange() {
        if (this.props.onExpandedChange) {
            this.props.onExpandedChange(this.state.isOpen);
        }
    }
    open() {
        this.setState({
            isOpen: true
        }, ()=>this._onExpandedChange());
    }
    onPopoverClick() {
        if (this.state.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
    close() {
        if (this.state.isOpen) {
            this.setState({
                isOpen: false
            }, this._onExpandedChange);
        }
    }
    getSelectedOption() {
        return this.dropdownContentRef ? this.dropdownContentRef.getSelectedOption() : null;
    }
    onKeyboardSelect() {
        const selectedOption = this.getSelectedOption();
        this.onOptionClick(selectedOption);
    }
    isClosingKey(key) {
        const { dropdownA11yFixes } = this.props;
        return key === 'Tab' || key === 'Escape' || !dropdownA11yFixes && key === 'Enter';
    }
    onKeyDown(evt) {
        const eventKey = evt.key;
        const { dropdownA11yFixes } = this.props;
        if (this.state.isOpen) {
            const handleSelect = ()=>{
                this.onKeyboardSelect();
                !this.props.multi && this.close();
                if (this.getSelectedOption() !== null) {
                    evt.preventDefault();
                }
            };
            switch(eventKey){
                case 'Tab':
                case 'Enter':
                    {
                        handleSelect();
                        if (dropdownA11yFixes) {
                            evt.preventDefault();
                        }
                        break;
                    }
                case 'Escape':
                    {
                        this.close();
                        break;
                    }
                default:
            }
        } else {
            if (this.isClosingKey(eventKey)) {
                return;
            }
            if (dropdownA11yFixes) {
                if (eventKey === 'Enter' || eventKey === ' ' || eventKey === 'ArrowDown' || eventKey === 'ArrowUp') {
                    evt.preventDefault();
                } else if (/^.$/u.test(evt.key)) {
                    // `key` matches a single unicode character - user is typing
                    this.open();
                } else {
                    return;
                }
            }
            if (eventKey === 'Unidentified') {
                return;
            }
            this.open();
        }
        this.dropdownContentRef && this.dropdownContentRef.onKeyDown(eventKey, evt);
    }
    _onContentMouseDown(e) {
        const { onContentMouseDown } = this.props;
        onContentMouseDown && onContentMouseDown(e);
    }
    onOptionHover(option) {
        if (this.props.onOptionHover) {
            this.props.onOptionHover(option);
        }
    }
    onOptionClick(option) {
        const { onSelect, onDeselect, multi, allowReselect } = this.props;
        const { selectedIds } = this.state;
        const newState = {
            isOpen: !!multi,
            selectedIds
        };
        let callback = onSelect;
        if (multi) {
            // Multi select
            if (option) {
                // if option was clicked (could be null when Autocomplete receives a new string)
                if (selectedIds.includes(option.id)) {
                    // if clicked a selected option, unselect it
                    newState.selectedIds = selectedIds.filter((x)=>x !== option.id);
                    callback = onDeselect;
                } else {
                    // if clicked a new option, add it to selection
                    newState.selectedIds = [
                        ...selectedIds,
                        option.id
                    ];
                }
            }
        // Single select
        } else if (option) {
            // if option was clicked (could be null when Autocomplete receives a new string)
            if (selectedIds.includes(option.id)) {
                this.close();
                if (!allowReselect) {
                    // if clicked on the selected item, exit and do nothing
                    return;
                }
            } else {
                // if clicked on a new option, make it the selected
                newState.selectedIds = [
                    option.id
                ];
            }
        } else {
            // if non existing option selected, unselect existing ones
            newState.selectedIds = [];
        }
        this.setState(newState, ()=>callback(option));
    }
    render() {
        const { openTrigger, placement, options, children, showArrow, fixedFooter, fixedHeader, disabled, readOnly, timeout, forceContentElementVisibility, style: inlineStyles, id, flip, fixed, moveBy, role, contentId, optionsContainerZIndex, dynamicWidth, appendTo, className, contentClassName, focusOnOption, contentRole, eventsEnabled, noResultsText } = this.props;
        const { isOpen, selectedIds } = this.state;
        const hasContent = Boolean(options && options.length || fixedHeader || fixedFooter);
        const shown = forceContentElementVisibility || isOpen && !disabled && !readOnly && hasContent;
        return /*#__PURE__*/ React.createElement(CorePopover, {
            className: st(classes.root, {
                'content-visible': shown
            }, className),
            contentClassName: contentClassName,
            placement: placement,
            shown: shown,
            showArrow: showArrow,
            timeout: timeout,
            onClickOutside: this.handleClickOutside,
            onClick: !disabled && !readOnly && openTrigger === CLICK ? ()=>this.onPopoverClick() : undefined,
            onMouseEnter: !disabled && !readOnly && openTrigger === HOVER ? ()=>this.open() : undefined,
            onKeyDown: !disabled && !readOnly ? this.onKeyDown : undefined,
            onMouseLeave: !disabled && !readOnly && openTrigger === HOVER ? this.close : undefined,
            style: inlineStyles,
            id: id,
            flip: flip,
            fixed: fixed,
            moveBy: moveBy,
            role: role,
            zIndex: optionsContainerZIndex,
            dynamicWidth: dynamicWidth,
            appendTo: appendTo,
            eventsEnabled: eventsEnabled,
            ...filterDataProps(this.props)
        }, /*#__PURE__*/ React.createElement(CorePopover.Element, null, children), /*#__PURE__*/ React.createElement(CorePopover.Content, null, /*#__PURE__*/ React.createElement(CoreDropdownContent, {
            className: classes.dropdownContent,
            role: contentRole,
            "data-hook": "dropdown-content",
            ref: (dropdownContent)=>this.dropdownContentRef = dropdownContent,
            options: options,
            fixedFooter: fixedFooter,
            fixedHeader: fixedHeader,
            selectedIds: selectedIds,
            onOptionClick: this.onOptionClick,
            onOptionHover: this.onOptionHover,
            onMouseDown: this._onContentMouseDown,
            optionsContainerId: contentId,
            focusOnOption: focusOnOption,
            noResultsText: noResultsText
        })));
    }
    constructor(props){
        super(props), _define_property(this, "dropdownContentRef", null), _define_property(this, "state", {
            isOpen: false,
            selectedIds: []
        });
        this.close = this.close.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onPopoverClick = this.onPopoverClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onOptionHover = this.onOptionHover.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this._onContentMouseDown = this._onContentMouseDown.bind(this);
    }
}
_define_property(CoreDropdownComponent, "displayName", 'CoreDropdown');
_define_property(CoreDropdownComponent, "areSelectedIdsEqual", (selectedIds1, selectedIds2)=>{
    if (selectedIds1 === undefined && selectedIds2 === undefined || selectedIds1 === null && selectedIds2 === null) {
        return true;
    }
    return Array.isArray(selectedIds1) && Array.isArray(selectedIds2) && selectedIds1.length === selectedIds2.length && selectedIds1.every((item, index)=>item === selectedIds2[index]);
});
export const CoreDropdown = CoreDropdownComponent;

//# sourceMappingURL=CoreDropdown.js.map